module.exports = __webpack_public_path__ + "img/Bills@1x.283eb76d.svg";